import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EscolaModel } from '../models/escola.model';
import { ApiVersion, ApiService } from 'src/app/services/api.service';
import { Observable } from 'rxjs';
import { ComentarioProfessorModel } from '../models/professor.model';

@Injectable()
export class ComentariosService {
    constructor(private http: HttpClient, private apiService: ApiService) {}

    getObservacao(hashAluno: string): Observable<any> {
        return this.http.get(
            `${this.apiService.getUrl()}/${ApiVersion}/observacoes/${hashAluno}`
        );
    }

    salvarObservacao(hashAluno: string, observacao: any): Observable<any> {
        return this.http.put(
            `${this.apiService.getUrl()}/${ApiVersion}/observacoes/${hashAluno}`,
            observacao
        );
    }

    salvarObservacaoComentario(hashAluno: string, observacao: any): Observable<any> {
      return this.http.post(
          `${this.apiService.getUrl()}/${ApiVersion}/quesitos/salvar-comentario/${hashAluno}`,
          observacao
      );
    }

    getPOAComentario(hashAluno: string): Observable<any> {
      return this.http.get(
          `${this.apiService.getUrl()}/${ApiVersion}/quesitos/poa-comentario/${hashAluno}`
      );
    }


    salvarComentario({ hashPessoa, hashProfessor, comentarioProfessor }):
     Observable<ComentarioProfessorModel> {
        return this.http.post<ComentarioProfessorModel>(
            `${this.apiService.getUrl()}/${ApiVersion}/quesitos/salvar-comentario-professor`,
            {
                hashPessoa,
                hashProfessor,
                comentarioProfessor
            }
        );
      }
}
